import { render, staticRenderFns } from "./CardsTasks.vue?vue&type=template&id=2f1ee80c&scoped=true&"
import script from "./CardsTasks.vue?vue&type=script&lang=js&"
export * from "./CardsTasks.vue?vue&type=script&lang=js&"
import style0 from "./CardsTasks.vue?vue&type=style&index=0&id=2f1ee80c&lang=scss&scoped=true&"
import style1 from "./CardsTasks.vue?vue&type=style&index=1&id=2f1ee80c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1ee80c",
  null
  
)

export default component.exports